import {
  GET_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_FAILED,
  GET_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_REQUEST,
  GET_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_SUCCESS,
  RESET_SETTINGS,
  SAVE_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_FAILED,
  SAVE_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_REQUEST,
  SAVE_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_SUCCESS,
  SET_AUDIO_START_TIME,
  SET_AUTO_SCROLL_WITH_SYNC,
  SET_FONT_SIZE,
  SET_OPEN_SPEAKER_MODAL,
  SET_REWIND_TIME,
  SET_SYNC_WITH_AUDIO,
  UPDATE_LAST_WORKED_PARAGRAPH,
  UPLOAD_LEGAL_DOCUMENT_FAILED,
  UPLOAD_LEGAL_DOCUMENT_REQUEST,
  UPLOAD_LEGAL_DOCUMENT_SUCCESS,
} from '../../../../constants/ActionNameConstants';

const initialValues = {
  rewindTime: 5,
  fontSize: 16,
  syncWithAudio: true,
  autoScrollWithSync: false,
  audioStartTime: 0,
  openSpeakerModalId: null,
  lastWorkedParagraph: null,
  legalTemplateFormFieldDetails: null,
  isLoadingLegalTemplateFormFieldDetails: false,
  isLoadingSaveOrUpdateTemplateFormDetails: false,
  isUploadedLegalDocument: false,
};

const settingsReducer = (state = initialValues, action) => {
  switch (action.type) {
    case SET_REWIND_TIME:
      return {
        ...state,
        rewindTime: action.payload,
      };
    case SET_FONT_SIZE:
      return {
        ...state,
        fontSize: action.payload,
      };
    case SET_OPEN_SPEAKER_MODAL:
      return {
        ...state,
        openSpeakerModalId: action.payload,
      };
    case RESET_SETTINGS:
      return {
        ...initialValues,
      };
    case SET_SYNC_WITH_AUDIO:
      return {
        ...state,
        syncWithAudio: action.payload,
      };
    case SET_AUTO_SCROLL_WITH_SYNC:
      return {
        ...state,
        autoScrollWithSync: action.payload,
      };
    case SET_AUDIO_START_TIME:
      return {
        ...state,
        audioStartTime: action.payload,
      };
    case UPDATE_LAST_WORKED_PARAGRAPH:
      return {
        ...state,
        lastWorkedParagraph: action.payload,
      };
    case GET_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_REQUEST:
      return {
        ...state,
        isLoadingLegalTemplateFormFieldDetails: true,
      };
    case GET_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_SUCCESS:
      return {
        ...state,
        legalTemplateFormFieldDetails: action.payload,
        isLoadingLegalTemplateFormFieldDetails: false,
      };
    case GET_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_FAILED:
      return {
        ...state,
        isLoadingLegalTemplateFormFieldDetails: false,
      };
    case SAVE_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_REQUEST:
      return {
        ...state,
        isLoadingSaveOrUpdateTemplateFormDetails: true,
      };
    case SAVE_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_SUCCESS:
      return {
        ...state,
        isLoadingSaveOrUpdateTemplateFormDetails: false,
      };
    case SAVE_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_FAILED:
      return {
        ...state,
        isLoadingSaveOrUpdateTemplateFormDetails: false,
      };
    case UPLOAD_LEGAL_DOCUMENT_REQUEST:
      return {
        ...state,
        isUploadedLegalDocument: false,
      };
    case UPLOAD_LEGAL_DOCUMENT_SUCCESS:
      return {
        ...state,
        isUploadedLegalDocument: true,
      };
    case UPLOAD_LEGAL_DOCUMENT_FAILED:
      return {
        ...state,
        isUploadedLegalDocument: false,
      };
    default:
      return state;
  }
};

export default settingsReducer;
